<template>
  <div id="app">
    <div id="page">
      <header class="header menu_fixed">
        <div class="site-logo">
          <a href="/">
            <img
              src="./assets/img/logo_white_letters.svg"
              alt="Ada Bojana For Me"
              class="logo_normal"
            />
            <img
              src="./assets/img/logo_color_letters.svg"
              alt="Ada Bojana For Me"
              class="logo_sticky"
            />
          </a>
        </div>

        <a href="#menu" class="btn_mobile">
          <div class="hamburger hamburger--spin" id="hamburger">
            <div class="hamburger-box">
              <div class="hamburger-inner"></div>
            </div>
          </div>
        </a>
        <nav id="menu" class="main-menu">
          <ul>
            <li>
              <span><a href="/">Home</a></span>
            </li>
            <li>
              <span>
                <a href="javascript:">{{ $t("menu.accommodation") }}</a>
              </span>
              <ul>
                <li v-for="(type, index) in propertyTypes" :key="index">
                  <a :href="type.url">{{ type.title }}</a>
                </li>
              </ul>
            </li>
            <li>
              <span>
                <a href="javascript:">{{ $t("menu.locations") }}</a>
              </span>
              <ul>
                <li v-for="(city, index) in cities" :key="index">
                  <a :href="'/city/' + city.slug">{{ city.title }}</a>
                </li>
              </ul>
            </li>
            <li>
              <span>
                <a href="javascript:">Aktivnosti</a>
              </span>
              <ul>
                <li><a href="/aktivnosti?category=activity">Kitesurf</a></li>
                <li><a href="/aktivnosti?category=tour">Iznajmljivanje čamaca</a></li>
                <li><a href="/aktivnosti?category=restaurant">Restorani</a></li>
                <li><a href="/aktivnosti?category=activity">Plaže</a></li>
                <li><a href="/aktivnosti?category=activity">Barovi</a></li>
              </ul>
            </li>
            <li>
              <span>
                <a href="/blog">{{ $t("menu.blog") }}</a>
              </span>
            </li>
            <li>
              <span>
                <a href="/contact">{{ $t("menu.contact") }}</a>
              </span>
            </li>
          </ul>
        </nav>
      </header>
      <!-- /header -->

      <div class="route-shell">
        <router-view />
      </div>

      <!-- Newsletter Section - Na svakoj stranici iznad footera -->
      <Newsletter />

      <!-- Footer -->
      <Footer />
    </div>

    <CookieBanner />
    <CookiePreferencesModal />

    <!-- Sign In Popup -->
    <sign-in-popup></sign-in-popup>
    <!-- /Sign In Popup -->

    <div id="toTop"></div>
    <!-- Back to top button -->
  </div>
</template>

<script>
import SignInPopup from "@/components/SignInPopup";
import Newsletter from "@/components/Newsletter";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import CookiePreferencesModal from "@/components/CookiePreferencesModal";
import { mapGetters } from "vuex";
import i18nService from "@/services/i18n.service.js";

export default {
  name: "App",
  components: {
    SignInPopup,
    Newsletter,
    Footer,
    CookieBanner,
    CookiePreferencesModal,
  },
  metaInfo() {
    const siteUrl = (process.env.VUE_APP_BASE_URL || "https://adabojanaforme.com").replace(/\/$/, "");
    const baseUrl = siteUrl + this.$route.path;
    const metaTitle = "Ada Bojana smeštaj: apartmani i sojenice";
    const metaDescription =
      "Rezervišite smeštaj na Adi Bojani: apartmani, kuće i sojenice blizu Velike plaže i Ulcinja za miran odmor uz more i reku.";
    const metaImage = `${siteUrl}/img/iStock-Hero1.webp`;
    const organizationSchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": `${siteUrl}/#organization`,
          name: "Ada Bojana For Me",
          url: siteUrl,
          logo: `${siteUrl}/img/logo_color_letters.svg`,
          email: "info@adabojanaforme.com",
          sameAs: [
            "https://sr-rs.facebook.com/adabojanaforme",
            "https://www.instagram.com/adabojanaforme",
            "https://www.tiktok.com/@adabojanaforme",
            "https://www.linkedin.com/company/adabojanaforme",
          ],
        },
        {
          "@type": "WebSite",
          "@id": `${siteUrl}/#website`,
          url: siteUrl,
          name: "Ada Bojana For Me",
          description: metaDescription,
          publisher: {
            "@id": `${siteUrl}/#organization`,
          },
          inLanguage: "sr-RS",
        },
      ],
    };

    return {
      title: metaTitle,
      titleTemplate: "%s | Ada Bojana For Me",
      meta: [
        {
          name: "description",
          content: metaDescription,
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:url",
          content: baseUrl,
        },
        {
          property: "og:title",
          content: `${metaTitle} | Ada Bojana For Me`,
        },
        {
          property: "og:description",
          content: metaDescription,
        },
        {
          property: "og:image",
          content: metaImage,
        },
        {
          property: "twitter:card",
          content: "summary_large_image",
        },
        {
          property: "twitter:url",
          content: baseUrl,
        },
        {
          property: "twitter:title",
          content: `${metaTitle} | Ada Bojana For Me`,
        },
        {
          property: "twitter:description",
          content: metaDescription,
        },
        {
          property: "twitter:image",
          content: metaImage,
        },
        { name: "robots", content: "index,follow" },
      ],
      link: [
        {
          rel: "canonical",
          href: baseUrl,
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: organizationSchema,
        },
      ],
    };
  },
  data: function () {
    return {
      propertyTypes: [
        {
          title: this.$i18n.t("propertyTypes.all"),
          url: "/smestaj-ulcinj-ada-bojana",
        },
        { title: this.$i18n.t("propertyTypes.hotels"), url: "/listings/hotel" },
        {
          title: this.$i18n.t("propertyTypes.apartments"),
          url: "/listings/apartman",
        },
        { title: this.$i18n.t("propertyTypes.camps"), url: "/listings/kamp" },
        {
          title: this.$i18n.t("propertyTypes.river_houses"),
          url: "/listings/sojenica",
        },
      ],
      languages: i18nService.languages,
      selectedLanguage: i18nService.getActiveLanguage(),
    };
  },
  methods: {
    switchLanguage(event) {
      i18nService.setActiveLanguage(event.target.value);
      window.location.reload();
    },
  },
  computed: {
    ...mapGetters(["cities"]),
  },
};
</script>

<style lang="scss">
//GOOGLE WEB FONT
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Open+Sans:wght@300;400;500;600;700&display=swap");
@import "assets/css/main.scss";
@import "assets/css/bootstrap.css";
@import "assets/css/style.css";
@import "assets/css/vendors.css";
@import "assets/css/kolektiv.css";

/* ===== GLOBAL FONT RULES ===== */
html,
body {
  scroll-behavior: auto !important;
}

.Vue-Toastification__container {
  z-index: 2147483647 !important;
}

body {
  font-family: "Open Sans", sans-serif !important;
}

#page > .route-shell {
  min-height: 100svh;
}

h1,
h2,
h3,
h4,
h5,
h6,
.sectionTitle__title,
.hero-title,
.footer-tagline {
  font-family: "Montserrat", sans-serif !important;
}

/* ===== HEADER OVERRIDE ===== */

/* Pre-scroll SVE stranice: bela slova (top-level only) */
.header.menu_fixed nav#menu > ul > li > span > a {
  color: #ffffff !important;
}

.header.menu_fixed .hamburger-inner,
.header.menu_fixed .hamburger-inner::before,
.header.menu_fixed .hamburger-inner::after {
  background-color: #ffffff !important;
}

/* ===== HOME STICKY: bela pozadina + tamna slova ===== */
body.home-page-active .header.menu_fixed.sticky,
body.home-page-active .header.menu_fixed.is-sticky,
body.home-page-active .header.sticky,
body.home-page-active header.sticky,
body.home-page-active header.is-sticky,
body.home-page-active header[class*="sticky"] {
  background-color: #ffffff !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06) !important;
  background: #ffffff !important;
}

body.home-page-active .header.menu_fixed.sticky nav#menu > ul > li > span > a,
body.home-page-active .header.is-sticky nav#menu > ul > li > span > a,
body.home-page-active header[class*="sticky"] nav#menu > ul > li > span > a {
  color: #051036 !important;
}

body.home-page-active .header.menu_fixed.sticky .hamburger-inner,
body.home-page-active .header.menu_fixed.sticky .hamburger-inner::before,
body.home-page-active .header.menu_fixed.sticky .hamburger-inner::after,
body.home-page-active header[class*="sticky"] .hamburger-inner,
body.home-page-active header[class*="sticky"] .hamburger-inner::before,
body.home-page-active header[class*="sticky"] .hamburger-inner::after {
  background-color: #051036 !important;
}

/* ===== BLOG HEADER: always dark (sticky + non-sticky) ===== */
body.blog-page-active .header.menu_fixed,
body.blog-page-active .header.menu_fixed.sticky,
body.blog-page-active .header.menu_fixed.is-sticky,
body.blog-page-active .header.sticky,
body.blog-page-active header.sticky,
body.blog-page-active header.is-sticky,
body.blog-page-active header[class*="sticky"],
body.legal-page-active .header.menu_fixed,
body.legal-page-active .header.menu_fixed.sticky,
body.legal-page-active .header.menu_fixed.is-sticky,
body.legal-page-active .header.sticky,
body.legal-page-active header.sticky,
body.legal-page-active header.is-sticky,
body.legal-page-active header[class*="sticky"] {
  background-color: #051036 !important;
  background: #051036 !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2) !important;
}

body.blog-page-active .header.menu_fixed.sticky nav#menu > ul > li > span > a,
body.blog-page-active .header.is-sticky nav#menu > ul > li > span > a,
body.blog-page-active .header.menu_fixed nav#menu > ul > li > span > a,
body.blog-page-active header[class*="sticky"] nav#menu > ul > li > span > a,
body.legal-page-active .header.menu_fixed.sticky nav#menu > ul > li > span > a,
body.legal-page-active .header.is-sticky nav#menu > ul > li > span > a,
body.legal-page-active .header.menu_fixed nav#menu > ul > li > span > a,
body.legal-page-active header[class*="sticky"] nav#menu > ul > li > span > a {
  color: #ffffff !important;
}

body.blog-page-active .header.menu_fixed.sticky .hamburger-inner,
body.blog-page-active .header.menu_fixed.sticky .hamburger-inner::before,
body.blog-page-active .header.menu_fixed.sticky .hamburger-inner::after,
body.blog-page-active .header.menu_fixed .hamburger-inner,
body.blog-page-active .header.menu_fixed .hamburger-inner::before,
body.blog-page-active .header.menu_fixed .hamburger-inner::after,
body.blog-page-active header[class*="sticky"] .hamburger-inner,
body.blog-page-active header[class*="sticky"] .hamburger-inner::before,
body.blog-page-active header[class*="sticky"] .hamburger-inner::after,
body.legal-page-active .header.menu_fixed.sticky .hamburger-inner,
body.legal-page-active .header.menu_fixed.sticky .hamburger-inner::before,
body.legal-page-active .header.menu_fixed.sticky .hamburger-inner::after,
body.legal-page-active .header.menu_fixed .hamburger-inner,
body.legal-page-active .header.menu_fixed .hamburger-inner::before,
body.legal-page-active .header.menu_fixed .hamburger-inner::after,
body.legal-page-active header[class*="sticky"] .hamburger-inner,
body.legal-page-active header[class*="sticky"] .hamburger-inner::before,
body.legal-page-active header[class*="sticky"] .hamburger-inner::after {
  background-color: #ffffff !important;
}

body.blog-page-active .site-logo .logo_normal {
  display: block !important;
}

body.blog-page-active .site-logo .logo_sticky,
body.legal-page-active .site-logo .logo_sticky {
  display: none !important;
}

/* ===== MMENU OVER HEADER (mobile off-canvas) ===== */
.mm-menu.mm-offcanvas {
  z-index: 10020 !important;
}

.mm-blocker {
  z-index: 10010 !important;
}

.mm-opening .header.menu_fixed,
.mm-opened .header.menu_fixed,
.mm-wrapper_opening .header.menu_fixed,
.mm-wrapper_opened .header.menu_fixed {
  z-index: 10000 !important;
}

/* Force mobile menu to overlay (drawer) instead of pushing page content */
.mm-wrapper_opening #page.mm-slideout,
.mm-wrapper_opened #page.mm-slideout,
.mm-wrapper_opening #page,
.mm-wrapper_opened #page {
  transform: none !important;
  -webkit-transform: none !important;
}

/* ===== INCREASED NAV FONT SIZE ===== */
nav#menu.main-menu > ul > li > span > a {
  font-size: 16px !important;
  font-weight: 500;
  letter-spacing: 0.2px;
}

/* ===== LOGO SWAP ===== */
.site-logo a {
  display: inline-flex;
  align-items: center;
}

.site-logo img {
  display: block;
  width: 120px;
  height: auto;
}

.site-logo .logo_sticky {
  display: none;
}

header.header.sticky .site-logo .logo_normal,
header.menu_fixed.sticky .site-logo .logo_normal {
  display: block !important;
}

header.header.sticky .site-logo .logo_sticky,
header.menu_fixed.sticky .site-logo .logo_sticky {
  display: none !important;
}

body.home-page-active header.header.sticky .site-logo .logo_normal,
body.home-page-active header.menu_fixed.sticky .site-logo .logo_normal {
  display: none !important;
}

body.home-page-active header.header.sticky .site-logo .logo_sticky,
body.home-page-active header.menu_fixed.sticky .site-logo .logo_sticky {
  display: block !important;
}

nav#menu.main-menu ul ul li a {
  font-size: 15px !important;
}

/* ===== MOBILE HAMBURGER POSITION ===== */
.header .btn_mobile {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
}

@media (max-width: 991px) {
  header.header {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
  }

  header.header #preloader {
    display: none !important;
  }

  header.header .site-logo {
    order: 1 !important;
    flex: 0 0 70px !important;
    float: none !important;
    position: relative !important;
    left: auto !important;
    top: auto !important;
    width: 70px !important;
    max-width: 70px !important;
    text-align: left !important;
    margin: 0 !important;
  }

  header.header .site-logo a {
    width: 70px !important;
    max-width: 70px !important;
    justify-content: flex-start !important;
  }

  header.header .site-logo img {
    margin: 0 !important;
    width: 100% !important;
    max-width: 70px !important;
    height: auto !important;
  }

  header.header .btn_mobile {
    order: 2 !important;
    margin-left: auto !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    position: relative !important;
    transform: none !important;
    right: auto !important;
    top: auto !important;
    left: auto !important;
    min-height: 40px;
  }
}

body.search-overlay-open .header,
body.search-overlay-open #toTop,
body.ota-date-overlay-open .header,
body.ota-date-overlay-open #toTop {
  opacity: 0 !important;
  visibility: hidden !important;
  pointer-events: none !important;
}

select:not([multiple]):not([size]) {
  appearance: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10'%3E%3Cpath d='M1 3l4 4 4-4' fill='none' stroke='%23051036' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") !important;
  background-repeat: no-repeat !important;
  background-position: right 16px center !important;
  background-size: 10px 10px !important;
  padding-right: 40px !important;
}
</style>
